var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPagination)?_c('p',{attrs:{"data-component":"records-count"}},[_vm._v(" "+_vm._s(_vm.getCountString)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }